module.exports = __webpack_public_path__ + "static/media/ava.2fbf5ecb.svg";